import type { QuoteFile } from 'paintscout'

/**
 * Stamps `presentationOptions.isDocumentImage` on a Documents/Services row image before it's
 * passed to `InlineEditableMedia`, so its "View Document" button also shows for a non-PDF
 * document (ENG-1444). Display-only: not written back through `handleEdit`, so it's re-applied
 * fresh on every render rather than round-tripped through the saved quote document.
 */
export function markAsDocumentImage(file?: QuoteFile | null): QuoteFile | null {
  if (!file) {
    return null
  }

  return {
    ...file,
    presentationOptions: { ...file.presentationOptions, isDocumentImage: true }
  }
}
